import { render, staticRenderFns } from "./agentCourseAgencyDialog.vue?vue&type=template&id=3fb60f6c&scoped=true&"
import script from "./agentCourseAgencyDialog.vue?vue&type=script&lang=js&"
export * from "./agentCourseAgencyDialog.vue?vue&type=script&lang=js&"
import style0 from "./agentCourseAgencyDialog.vue?vue&type=style&index=0&id=3fb60f6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb60f6c",
  null
  
)

export default component.exports